<app-header [showPromotions]="showPromotions"></app-header>
<main>
  <router-outlet></router-outlet>
  <app-scroll-to-top-button></app-scroll-to-top-button>
</main>
<app-footer></app-footer>